import apiUrl from "../../../constants";
import axios from "axios";
import Paginate from "vuejs-paginate";
import CryptoJS from 'crypto-js';
import {
  Validator
} from "vee-validate";
import VueElementLoading from 'vue-element-loading';

export default {
  name: "SRRedisDetailsView",
  components: {
    Paginate,
    VueElementLoading
  },
  data: function() {
    return {
      modalShow: false,
      searchKeyValue: "",
      isLoading: false,
      resultCount: '',
      message:'Please enter mobile number to get the specific SR Details/Download to get All the SR Details',
      MobileNumber:''
    };
  },

  created: function() {

  },

  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail');
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusername = userdetail.username;
  },

  methods: {

    resetSearch(){
      this.searchKeyValue = '';
      this.userId = "";
      this.employeeID = "";
      this.olduserid = "";
      this.utype = "";
      this.resultCount = 0;
      this.message ='Please enter mobile number to get the specific SR Details/Download to get All the SR Details';
    },

    searchKey(){
      if(this.searchKeyValue == ''){
        this.resultCount = 0;
        this.message = 'Mobile Number should not be empty.';
      }else{
        this.getKeyDatabySearch();
      }
    },

    downloadAsExcel(){
      console.log("enter into downloadasexcel()");
      this.getXLSXData();
    },

    deleteUsers(){
      this.modalShow = true;
      this.MobileNumber = this.searchKeyValue;
      //this.deleteUsersDetails();
    },

    deleteModal() {
      this.modalShow = false
  },

    getKeyDatabySearch() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        mobilenumber: this.searchKeyValue
        });
      this.isLoading = true;
      axios({
        method: "POST",
        url: apiUrl.api_url + "external/getRedisDetails",
        data: this.input,
        headers: {
          'Authorization': 'Bearer' + myStr
        }

      }).then(
        result => {
          console.log(result);
          if (result.data.code == 200) {
            this.userId = result.data.data.userId;
            this.employeeID = result.data.data.employeeID;
            this.olduserid = result.data.data.olduserid;
            this.utype = result.data.data.utype;
            this.isLoading = false;
            this.resultCount = 1;
          } else {
            this.userId = "";
            this.employeeID = "";
            this.olduserid = "";
            this.utype = "";
            this.isLoading = false;
            this.resultCount = 0;
            this.message = 'Mobile Number not mapped with user.';
          }
        },
        error => {
          console.error(error);
        }
      );
    },
    getXLSXData() {
      console.log("enter into getXLSXData()");
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.isLoading = true;
      const CSV_EXTENSION = '.csv';
      axios({
        method: "POST",
        url: apiUrl.api_url + "external/getRedisDetailsinXLSX",
        headers: {
          'Authorization': 'Bearer' + myStr
        }

      }).then(
        async result => {
          var SR_Details = result.data.data;
          if (result.data.code == 200) {
            let csv = 'mobilenumber,employeeid,userid,olduserid,utype\n'
            SR_Details.forEach((row) => {
                    csv += row.mobilenumber+',';
                    csv += row.employeeid+',';
                    csv += row.userid+',';
                    csv += row.olduserid+',';
                    csv += row.utype+',';
                    csv += "\n";
            });
            const anchor = document.createElement('a');
            const filename = 'SR_Details'
            anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
            anchor.target = '_blank';
            anchor.download = filename+'_export_'+new Date().getTime()+CSV_EXTENSION;
            anchor.click();
            this.isLoading = false;
            this.resultCount = 0;
            this.message = 'SR User Verified details downloaded.'
          } else {
            this.resultCount = 0;
            this.message = 'SR User Details Not downloaded Properly'
          }
        },
        error => {
          console.error(error);
        }
      );
    },
    deleteUsersDetails(){
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        redisKey: this.searchKeyValue
        });
      axios({
        method: "POST",
        url: apiUrl.api_url + "external/deleteUserDetails",
        data: this.input,
        headers: {
          'Authorization': 'Bearer' + myStr
        }
      }).then(
        result => {
          console.log(result.data.code);
          if (result.data.code == 200) {
            this.userId = "";
            this.employeeID = "";
            this.olduserid = "";
            this.utype = "";
            this.resultCount = 0;
            this.message = `Mobile Number: ${this.searchKeyValue} deleted successfully`;
          } else {
            this.message = 'Mobile Number Not exist.'
          }
        },
        error => {
          console.error(error);
        }
      );
    },
  }
};



// WEBPACK FOOTER //
// ./src/views/components/SRRedisDetailsView/SRRedisDetails.component.js